module.exports = __webpack_public_path__ + "assets/diqiu.2c3dd760.svg";